import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { mobileCSS } from '@measures/responsive'

export interface TeamLiveScoreProps {
  liveScore: {
    qualifier: 'home' | 'away'
    homeScore: number
    awayScore: number
  }
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${mobileCSS(css`
    justify-content: flex-start;
  `)}
`

const SportLiveScore = styled.div<{ type: 'win' | 'loss' | 'draw' }>`
  ${({
    theme: {
      spacing: { spacing2, spacing4 },
      colors: { fillSport, fillBrand, staticWhite, staticNeutral600 },
      typography: {
        catchword: {
          medium2: { bundledCSS: medium2CatchwordCSS },
        },
      },
    },
    type,
  }) => css`
    ${medium2CatchwordCSS};
    padding: ${spacing2} ${spacing4};
    border-radius: ${spacing4};
    color: ${staticWhite};

    background-color: ${type === 'win'
      ? fillSport
      : type === 'loss'
        ? fillBrand
        : staticNeutral600};
  `}
`

const TeamLiveScore: FunctionComponent<TeamLiveScoreProps> = ({
  liveScore,
}) => {
  const teamScore =
    liveScore.qualifier === 'home' ? liveScore.homeScore : liveScore.awayScore

  const opponentScore =
    liveScore.qualifier === 'home' ? liveScore.awayScore : liveScore.homeScore

  const type =
    teamScore > opponentScore
      ? 'win'
      : teamScore < opponentScore
        ? 'loss'
        : 'draw'

  return (
    <Wrapper>
      <SportLiveScore type={type}>
        {teamScore}:{opponentScore}
      </SportLiveScore>
    </Wrapper>
  )
}

export default TeamLiveScore
